// XX: The file must be .js to be picked up by next-sitemap.config.js

// No index pages are marked as noIndex and noFollow in the `<head>` and excluded from sitemap.
// This hides them from external search engines.
export const noIndexPages = [
  "/pricing/mqrs",
  "/identity-resolution/overview",
  "/identity-resolution/usage",
  "/identity-resolution/golden-record",
  "/identity-resolution/model-configuration",
  "/identity-resolution/identifier-rules",
  "/ai-decisioning/agents",
  "/ai-decisioning/braze",
  "/ai-decisioning/collections",
  "/ai-decisioning/configuration",
  "/ai-decisioning/insights",
  "/ai-decisioning/inspector",
  "/ai-decisioning/iterable",
  "/ai-decisioning/overview",
  "/ai-decisioning/prepare-data",
  "/ai-decisioning/security",
  "/ai-decisioning/sfmc",
];
